import { LAW_IMG_PRE_PATH, GROUP_IMG_PRE_PATH, GOV_IMG_PRE_PATH, LINK_PRE_PATH, UrlPre } from './index';

export const headBg = UrlPre + 'PC/governmentLaw.jpg ';
export const headBgM = UrlPre + 'M/governmentLaw.jpg';
export const frameSrc = LAW_IMG_PRE_PATH + 'pc/80316c0f1f1c7cd21130bef10086e2810057aebf2e183bdcf960431b452b4bb4.jpg';
export const frameSrcM = LAW_IMG_PRE_PATH + 'm/ad2f70595cb7f15fafcb4c0928b1059814efb5d4c15bbadc81275816e5860ba4.jpg';

export const challenge = [
  {
    icon: LAW_IMG_PRE_PATH + 'pc/a85efa286f574d75719b15a926340b92b815c48b2ad2c07b888d5bbd8a056e91.png',
    title: '政法程序繁杂，亟需提质增效',
    desc: '政法案件复杂多样、程序繁杂，需创新开展“互联网+法律服务”便民工程，提升为民服务能力',
  },
  {
    icon: LAW_IMG_PRE_PATH + 'pc/9ecedf60d298432e70b2f38b74f90586df1b6387f7f35f5226a45ce859cba08d.png',
    title: '部门流转不高效，制约办案效率',
    desc: '政法案件流转涉及多部门联动，亟需打通数据流程，通过更智能的政法系统实现资源共享，达成高效协作',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/c2480ed47dccf91d0fbfe13becdbd77aabd271698442e83f646d2a7ad20f1a6d.png',
    title: '旧系统设备不一，孤岛式应用',
    desc: '政法应用场景多样，设备各异，难以突破信息孤岛，亟需推动办案、整改、治理贯通融合',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/3da2da93d9fe86f00a2869174d5d54cc4261f4d7f1da16b03f8db2fc0512e35b.png',
    title: '对信息安全及稳定性要求极高',
    desc: '因政法工作特性，对案件信息安全保障要求高，对国产化水平及应用稳定性要求高',
  },
];
export const frame = [
  {
    title: '高效视讯协同',
    icon: GOV_IMG_PRE_PATH + 'pc/bfb3d4b4b4b6729fa3595f0fc4c1ebb598a04a7d88399377c7eebc230cd20d0f.png',
  },
  {
    title: '跨部门流转协作',
    icon: LAW_IMG_PRE_PATH + 'pc/9a401e6f963dbfae539d904cea119af56658ef3786911cfc2703411c4101ba84.png',
  },
  {
    title: '融合互联互通 ',
    icon: GOV_IMG_PRE_PATH + 'pc/ed8c2ba4a6ab8fe18d0278c493f4cc93b488eed62aee613219605074829d8a4a.png',
  },
  {
    title: '信息安全稳定',
    icon: GOV_IMG_PRE_PATH + 'pc/7b22bddde2da475aff0ab5230102043bb66f9ffc7790e93bf76916e401538b8b.png',
  },
];
export const advantage = [
  {
    icon: GOV_IMG_PRE_PATH + 'pc/4590cfa05af1e13de69f30b03e39d868f390128919bc1804edb5392b8731186b.png',
    title: '强稳定可靠',
    desc: '运营级集群架构，MCU资源池，多活热备，7年不间断运营，打造了超大规模的政务云视频服务平台，无单点故障',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/ba7fb7ba0a0f40557012ce829250051134a7fa360fd790dde54e3b843ca4fa6a.png',
    title: '高安全保密',
    desc: '国密算法端到端全链路加密，内外网融合的灵活部署方式+全面安全机制，通过等保三级2.0+可信云双重安全资质认证',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/0c61ed2215d72793a025f868960559d79e32f8736569b0be67c1f23132891983.png',
    title: '超高清体验',
    desc: '全自研底层技术，具备完全自主核心知识产权，“云+端”国产化软硬件方案有效保障1080P/4K超高清体验',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/7a10983c134bfdc2a3fc06764228285a7976f145d399623699e963f6ae1144f9.png',
    title: '全场景覆盖',
    desc: '覆盖指挥中心、大中小会议室、桌面、移动端、无人机等各类型终端，可灵活接入司法内外网、司法专网、互联网、4G/5G等多网络环境',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/38dce2824d488c5ae758fce697cff2ea0c3ac160ed624d6a1be2eceae25be60b.png',
    title: '超融合应用',
    desc: '视频会议、监控、直播、录播、数据、语音融合互通，统一媒体接入能力，支撑政法各类业务应用',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/6168c4ec4c0a7e0c82929cfbc66642c110409b54265fd059e84212c0d45af7e7.png',
    title: '开放式集成',
    desc: '全面开放API/SDK，可融合现有音视频能力、司法业务系统，扩展AI能力，深度融合司法业务场景',
  },
];
export const scene = [
  {
    title: '远程庭审',
    desc: '原被告双方在线上即可出庭，全面提升审判效率',
    pcUrl: LAW_IMG_PRE_PATH + 'pc/fb341201ece69e2d10098009429f3377414fd9489f688d34188412fe9ff20b09.jpg',
  },
  {
    title: '远程提讯',
    desc: '可加快提讯、复核过程，节省人力物力，提高工作效率',
    pcUrl: LAW_IMG_PRE_PATH + 'pc/c2fad071391136c9e1cd835b70af03e3b74b490cb24ea9cb43aaa364944ea0fe.jpg',
  },
  {
    title: '移动警务',
    desc: '随时随地接入远程终端，快速开展警务，提高公安机关警务工作效率',
    pcUrl: LAW_IMG_PRE_PATH + 'pc/ea82030244cf651381f8fbcc6a72bc7974315132d29bb3b875a0724d0a46782c.jpg',
  },
  {
    title: '公开听证',
    desc: '听证终端通过云视频实现直播，并可推送至检察院指定的互联网平台',
    pcUrl: LAW_IMG_PRE_PATH + '63fd00f543818ff25c7dafe12e1aaf8b08e59c7cd7a99f12bdf44604dfe30134.jpg',
  },
  {
    title: '值班点名',
    desc: '指挥中心可对下属单位进行24小时视频画面监看和日常值班点名',
    pcUrl: LAW_IMG_PRE_PATH + 'pc/fab4a6bef31a3cc242b16a8b916da77f81ed92dd49d848de2c1dd673c74ac5fb.jpg',
  },
  {
    title: '对外沟通',
    desc: '通过App或微信小程序，实现与律师“云会议”、服刑人员家属“云探视”、互联网庭审等应用',
    pcUrl: LAW_IMG_PRE_PATH + 'pc/1766bfd2bbbe09c1a90e485311c56e9365111c837a1021477b226b5d3622019c.jpg',
  },
];
export const caseList = [
  [
    {
      logo: LAW_IMG_PRE_PATH + 'fd60e308c9bdd343b906904846e10f5e58e757a54d4c0d53a19240b2fa630f6e.jpg',
      title: '广东省司法厅',
      desc: '小鱼易连携手广东省司法厅共同推进公共法律服务平台建设，构建了覆盖全业务、功能完备、共融互通、便捷高效的公共法律服务体系，实现全市四级公共法律服务实体平台全覆盖。通过小鱼易连云视频，110接警员可将纠纷调解事件引导至12348律师服务，律师可与多方进行视频在线调解，及时解决问题，让每位公民的合法权益得到最大化保障，科技赋能“智慧司法”落地生根。',
      link: LINK_PRE_PATH + '649',
    },
    {
      logo: LAW_IMG_PRE_PATH + 'pc/e23a04b1ba6a51bad0693459865f60a83d298c3d947f61b9e8a0a4a41841cc1e.png',
      title: '中共大庆市委政法委员会',
      desc: '大庆政法委携手小鱼易连建设政法委云视频平台，集行政会议、视频会商、多级会议、指挥调度、班勤值守、培训学习等多维度业务场景应用于一体，实现视频应用对全人员、全业务、全流程“横向到边、纵向到底”打通，全面满足大庆市综治中心及下辖县、乡镇、村社等共700多个会场的云视频覆盖。',
      link: LINK_PRE_PATH + '1077',
    },
    {
      logo: LAW_IMG_PRE_PATH + 'f839a39830daa6460370c63acfda2d3d81a6e01f69b1e835556cd3aace86e4f1.jpg',
      title: '吉林省高速公路公安局',
      desc: '吉林省高速公路公安局携手小鱼易连打造了可视化接处警及指挥调度系统云平台，构建了以省局指挥中心为龙头、14个分局指挥中心为中枢的“信息整合平台”，可有效接入监控资源、会议资源、语音资源、报警信息、地理信息、业务数据等应用，提升了接警与应急指挥调度管控能力，为省局统一调度和全局决策提供强有力的技术支撑。',
      link: LINK_PRE_PATH + '9120ce',
    },
    {
      logo: LAW_IMG_PRE_PATH + '4a3363df90790ba409f43a035f0432666a04b3e56767f4d8add373b97ea73362.jpg',
      title: '四川省人民检察院',
      desc: '四川省检察院基于小鱼易连政法行业云视频解决方案，打造依托公网的四川省检务云视频能力平台，高效与检察业务系统进行音视频整合，实现内部视频办公、办案协同、办案指挥、律师会见、远程接访等多场景创新应用，全面推动检务模式创新升级。',
      link: LINK_PRE_PATH + '1047',
    },
    {
      logo: LAW_IMG_PRE_PATH + '52fb9f384906d780098fe5e6c77d6db116be00c6303bfdfd9ea1ce0a042439ae.jpg',
      title: '甘肃省高级人民法院',
      desc: '甘肃省高级人民法院为缓解日益紧张的司法资源，减轻法官办案压力、提高审判质效，携手小鱼易连建立了远程视频提讯系统，实现对全省74家看守所的云视频全覆盖，满足对辖区内所有远程视频提讯终端的统一监控和调度，为法庭调查、举证、质证、宣判等庭审环节建立了高清互动的远程视讯应用，体现了“智慧法院”建设的创新成果。',
      link: LINK_PRE_PATH + '1105',
    },
    {
      logo: LAW_IMG_PRE_PATH + 'pc/b6468dd9428c046306a169a32fefe541f10741e3f6284f9406612c632da0a083.png',
      title: '北京互联网法院',
      desc: '北京互联网法院基于小鱼易连云视频，打造了“全程在线”审理的在线庭审模式，实现案件受理、送达、调解、证据交换、庭前准备、庭审、宣判等诉讼环节全程网络化。小鱼易连的应用，让庭审模式从“面对面”到“键对键”，实践了“互联网法庭”新模式，构建了涉网案件审判新机制，让司法程序更加高效、便捷。',
      link: LINK_PRE_PATH + 'ce972e',
    },
  ],
];
